import _ from "lodash";
import t from "typy";
import { VueEditor } from "vue2-editor";
import ConfirmationModalComponent from "../components/confirmation-modal.component";
import LanguageButtonComponent from "../../dashboard/components/language-button.component";
import preCheckinPreview from "../components/preCheckinPreview";
import sendTestEmail from "../components/sendTestEmail";

export default {
  components: {
    VueEditor,
    ConfirmationModalComponent,
    LanguageButtonComponent,
    preCheckinPreview,
    sendTestEmail
  },
  data() {
    return {
      data: {
        value: {},
      },
      checkout: {
        value: {},
      },
      precomplete: {
        value: {},
      },
      customToolbar: [
        ["bold", "italic", "underline", "link"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
      availableLanguages: [],
      config: {
        saved: false,
      },
      lang: '',
    };
  },
  async mounted() {
    this.data.facility_id = window._app_facility.id;
    this.checkout.facility_id = window._app_facility.id;
    this.precomplete.facility_id = window._app_facility.id;
    this.show(this.$i18n.locale);
  },
  methods: {
    async show(lang) {
      this.lang = lang;

      const facilityId = window._app_facility.id;

      // helper to normalize one message
      const loadMsg = async (name) => {
        const res = await this.$lionheart.get(`/custom-messages/${facilityId}`, { params: { name } });
        const item = res?.data?.data || {};

        // read html from value.html (new) or value (legacy string)
        let html = '';
        const v = item.value;
        if (v && typeof v === 'object' && typeof v.html === 'string') {
          html = v.html;                 // new format
        } else if (typeof v === 'string') {
          html = v;                      // legacy string
        }

        return {
          ...item,
          facility_id: facilityId,
          name,
          value: { html }, // keep undefined if none to preserve default
        };
      };

      // names
      const checkinMsg      = `message-template-1-${lang}`;
      const checkoutMsg     = `message-checkout-1-${lang}`;
      const precompleteMsg   = `pre-complete-email-${lang}`;

      // load in parallel
      const [data, checkout, precomplete] = await Promise.all([
        loadMsg(checkinMsg),
        loadMsg(checkoutMsg),
        loadMsg(precompleteMsg),
      ]);

      this.data     = data;
      this.checkout    = checkout;
      this.precomplete = precomplete;

      this.config.saved = false;
    },
    async submit(data) {
      if (!data) return;

      const normalize = (rec) => ({
        id: rec.id ?? undefined,
        name: rec.name,
        facility_id: window._app_facility.id,
        value: { ...(rec.value || {}), html: rec.value?.html || "" },
      });

      const postMessage = async (rec) => {
        const { data } = await this.$lionheart.post("/custom-messages", normalize(rec));
        return data.data;
      };

      try {
        this.config.saved = false;

        this.data = await postMessage(this.data);

        if (this.$parent.facility.has_pms) {
          const [precomplete,data,checkout] = await Promise.all([
            postMessage(this.precomplete),
            postMessage(this.data),
            postMessage(this.checkout),
          ]);
          this.precomplete = precomplete;
          this.data = data;
          this.checkout = checkout;
        }

        this.config.saved = true;
        window.scrollTo(0, 0);
      } catch (e) {
        this.config.saved = false;
        const msg = e?.response?.data?.message || e.message || "Save failed";
        this.errorDisplay({ error: { msg } });
      }
    },
    errorDisplay(d) {
      this.error_msg = d.error.msg;
      setTimeout(
        () => window.scrollTo(0, $("#error_msg").position().top - 10),
        300
      );
      return;
    },
  },
};
